
import { GetDocumentTypeListQuery } from "../model/GetDocumentTypeListQuery";
import { getDocumentTypeList, getListOfGroup, getUsersToDoList, getListOfFolderByGroupId, getCustomerData, updateDocumentStatusForOnHold, getDocumentFileDetailsById, IndexDocument, AddDocNotes, GetDocHistory, CloseDocument, RedirectDocuments, deleteDocumentAPI, hardLockDocument, toggleDocumentLock, releaseSoftLockDocuments } from "../services/DocuMateAPI";
import { DocQueueGroupListResponseDto } from "../model/DocQueueGroupListResponseDto";
import LookupService from "../../Services/LookupService";
import { GetCustomerDataQuery } from "../model/GetCustomerDataQuery";
import { DocumentOnHoldStatusResponseDto } from "../model/DocumentOnHoldStatusResponseDto";
import { DocumentFileDetailsResponseDto } from "../model/DocumentFileDetailsResponseDto";
import { RedirectDocumentCommand } from "../model/RedirectDocumentCommand";
import { GetFolderListByGroupIdQuery } from '../model/GetFolderListByGroupIdQuery';
import * as docuMateConstant from '../shared/util/docuMateConstant';
import { DocumentCloseResponseDto } from "../model/DocumentCloseResponseDto";
class DocuMateIndexingService {

    getListOfDocumentType = async (getDocumentTypeListRequestModel: GetDocumentTypeListQuery) => {
        var documentTypeListResponse = await getDocumentTypeList(getDocumentTypeListRequestModel);
        let res = [];
        if (documentTypeListResponse.length > 0) {
            res = documentTypeListResponse.map((item) => ({
                value: item.id,
                label: item.type,
            }));
        }

        return res;
    }

    GetListOfGroup = async () => {
        var GroupList = await getListOfGroup(true);
        const groupList = GroupList.map((item: DocQueueGroupListResponseDto) => (
            {
                value: item.id,
                label: item.groupName
            }));

        return groupList;
    }

    GetFolderListByGroupId = async (getFolderListByGroupIdQuery: GetFolderListByGroupIdQuery) => {
        var FolderDocData = await getListOfFolderByGroupId(getFolderListByGroupIdQuery);
        const folderList = FolderDocData.map((item) =>
        ({
            label: item.folderName,
            value: item.id
        }));


        return folderList;
    }


    getUsersToDoList = async (groupList: string[]) => {
        var UsersData = await getUsersToDoList(groupList);
        var users = [];

        UsersData.forEach(item => {
            var dataUser = {
                label: item.displayName ?? '',
                value: item.id,
                status: 'active',
                isInactive: false
            }

            users = [...users, dataUser];
        });

        return users;
    }

    GetRedirectReason = async () => {
        let RedirectReasonList = await LookupService.fetchRedirectReason();
        let RedirectReasonOptions = RedirectReasonList.map((item) => ({
            label: item.lookupValue,
            value: item.id,
            isInactive: false

        }));
        return RedirectReasonOptions;
    }

    GetCustomerData = async (getCustomerDataQueryModel: GetCustomerDataQuery) => {
        var customerDataResponseDto = await getCustomerData(getCustomerDataQueryModel);
        const dataArray = [customerDataResponseDto];
        return dataArray;
    }

    updateDocumentStatusForOnHold = async (id: string): Promise<DocumentOnHoldStatusResponseDto> => {
        var responseData = await updateDocumentStatusForOnHold(id);
        return responseData;
    }

    GetDocumentFileDetailsById = async (id: string): Promise<DocumentFileDetailsResponseDto> => {
        var filedetails = await getDocumentFileDetailsById(id);
        return filedetails;
    }

    IndexDocument = async (id: string, toAppId: number, DocumentTypeId: string, indexKey1: string, indexKey2: string, attributes: string): Promise<any> => {
        var indexingResponse = await IndexDocument(id, toAppId, DocumentTypeId, indexKey1, indexKey2, attributes);
        return indexingResponse;
    }

    AddDocNotes = async (Id: string, comment: string) => {
        const response = await AddDocNotes(Id, comment);
        return response.map((item) => {
            return {
                ...item
            };
        });
    }

    GetDocHistory = async (entityId: string) => {
        var history = await GetDocHistory(entityId)
        return history.map((item) => {
            return {
                ...item
            };
        });
    }

    CloseDocument = async (Id: string): Promise<DocumentCloseResponseDto> => {
        const response = await CloseDocument(Id);
        return response;
    }

    UpdateRedirectData = async (redirectDocumentCommand: RedirectDocumentCommand) => {
        var redirectDataResponseDto = await RedirectDocuments(redirectDocumentCommand);
        return redirectDataResponseDto;
    }

    public validateRedirectDocument = (redirectDocumentCommand: RedirectDocumentCommand): any => {
        let validationErrors: any = {};

        if (!redirectDocumentCommand) {
            validationErrors['rootObject'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }

        if (!redirectDocumentCommand.GroupId || redirectDocumentCommand.GroupId.trim().length === 0) {
            validationErrors['GroupId'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }

        if (!redirectDocumentCommand.FolderId || redirectDocumentCommand.FolderId.trim().length === 0) {
            validationErrors['FolderId'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }

        if (!redirectDocumentCommand.RedirectReason || redirectDocumentCommand.RedirectReason.trim().length === 0) {
            validationErrors['RedirectReason'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        
        if (
            (redirectDocumentCommand.RedirectReason === docuMateConstant.redirectReasonMandatory ||
                redirectDocumentCommand.RedirectReason === docuMateConstant.redirectReasonOther) &&
            (!redirectDocumentCommand.RedirectNote || redirectDocumentCommand.RedirectNote.trim().length === 0)
        ) {
            validationErrors['RedirectNote'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }

        return validationErrors;
    }

    validateIndexDocumentType = (documentTypeOption: string) => {
        const validationErrors: any = {};

        if (!documentTypeOption) {
            validationErrors['documentType'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        return validationErrors;
    };

    deleteDocument = async (listOfDocument: string[]) => {
        var res = await deleteDocumentAPI(listOfDocument);
        return res;
    }
    
    hardLockDocument = async (documentId: string) => {
        return await hardLockDocument(documentId);
    }

    toggleDocumentLock = async (documentId: string, markLock: boolean) => {
        return await toggleDocumentLock(documentId, markLock);
    }

    releaseSoftLockDocuments = async () => {
        return await releaseSoftLockDocuments();
    }
}

export default DocuMateIndexingService;